import React from 'react';
import { format } from 'date-fns';
import { COLLECT_PLUS_OWNER_ID } from '../../constants/clickCollectConstants';

export function getDeliveryMethodText(props) {
  const {
    isGreenVanFleet,
    isGreenVanFleetExCatchment,
    isGreenVanFleetUnavailable,
    isTradeplaceDelivery,
    method,
  } = props;

  if (isTradeplaceDelivery) {
    return 'Delivery from our approved supplier';
  }

  if (isGreenVanFleet) {
    if (isGreenVanFleetExCatchment) {
      return 'UK delivery usually within 7-14 working days';
    }
    if (isGreenVanFleetUnavailable) {
      return 'Standard specialist delivery';
    }
  }
  return method;
}

export function getDeliveryInfoText(props) {
  const {
    additionalInformation,
    collectionTime,
    ownerId,
    deliveryInfo,
    isClickCollectHeadOffice,
    isClickCollectOrder,
    isGreenVanFleet,
    isGreenVanFleetExCatchment,
    isGreenVanFleetUnavailable,
    isGvfSlotGreaterThanTwoHours,
    isMadeToMeasureDelivery,
    isOneManDayDelivery,
    isOneManEveningDelivery,
    isOneManMorningDelivery,
    isTradeplaceDelivery,
    oneManPremiumDeliverySelectedDate,
  } = props;

  if (isClickCollectOrder) {
    if (isClickCollectHeadOffice) {
      // Handled in DisplayDeliveryDetails.jsx
      return undefined;
    }

    const collectionDateTimeText = (ownerId === COLLECT_PLUS_OWNER_ID) ?
      <span>
        <p>Your order will be ready for collection on <strong>{format(collectionTime, 'dddd D MMMM YYYY')}</strong>.</p>
        <p>You&apos;ll be notified when it&apos;s ready for collection & your order will be kept for 10 days.</p>
      </span> : <span>Your order will be ready to collect from <strong>{format(collectionTime, 'h:mma')}</strong> on <strong>{format(collectionTime, 'dddd D MMMM YYYY')}</strong>. We&apos;ll keep your order for 7 days.</span>;

    return collectionDateTimeText;
  }

  const standardDatePattern = 'dddd DD MMMM';

  if (isOneManEveningDelivery) {
    return (
      <span>Arriving on{' '}
        <strong>{format(oneManPremiumDeliverySelectedDate, standardDatePattern)}</strong>{' '}
        between <strong>7pm - 10pm</strong>
      </span>
    );
  }

  if (isOneManMorningDelivery) {
    return (
      <span>Arriving on{' '}
        <strong>{format(oneManPremiumDeliverySelectedDate, standardDatePattern)}</strong>{' '}
        between <strong>7.30am - 10.30am</strong>
      </span>
    );
  }

  if (isOneManDayDelivery) {
    return (
      <span>Arriving on{' '}
        <strong>{format(oneManPremiumDeliverySelectedDate, standardDatePattern)}</strong>{' '}
        between <strong>8am - 8pm</strong>
      </span>
    );
  }

  if (isTradeplaceDelivery) {
    return (
      <span>
        Your order will be delivered on{' '}
        <strong>{format(deliveryInfo.date, standardDatePattern)}</strong>.{' '}
        Our supplier will contact you to confirm your delivery time.
      </span>
    );
  }

  if (isMadeToMeasureDelivery) {
    if (!deliveryInfo?.date) {
      return additionalInformation;
    }

    return (
      <span>
        Your order will be delivered on{' '}
        <strong>{format(deliveryInfo.date, standardDatePattern)}</strong>.
      </span>
    );
  }

  if (isGreenVanFleetExCatchment || isGreenVanFleetUnavailable) {
    return "We'll contact you within 2 working days to arrange a delivery time convenient for you.";
  }

  if (isGreenVanFleet) {
    const showAdditionalInfo = isGvfSlotGreaterThanTwoHours;
    const { date, startTime, endTime } = deliveryInfo;
    const deliveryInfoText = showAdditionalInfo ?
      (
        <span>
          Arriving on <strong>{format(date, standardDatePattern)}</strong>{' '}
          between <strong>{startTime} - {endTime}</strong>.{' '}
          The evening before your delivery we&apos;ll confirm a 2-hour delivery window.
        </span>
      ) :
      (
        <span>
          Arriving on <strong>{format(date, standardDatePattern)}</strong>{' '}
          between <strong>{startTime} - {endTime}</strong>.
        </span>
      );
    return deliveryInfoText;
  }

  return additionalInformation;
}
